// extracted by mini-css-extract-plugin
export default {"SettingsHeadline":"SettingsHeadline_SettingsHeadline__iSSYm"};